// APPLICATION

// review
export const APPLICATION_REVIEW_REPORT_MODAL_OPEN = 'APPLICATION_REVIEW_REPORT_MODAL_OPEN'
export const APPLICATION_REVIEW_REPORT_MODAL_CLOSE = 'APPLICATION_REVIEW_REPORT_MODAL_CLOSE'
